// Turns a clickable Box into a real button: Tab-focusable, Enter/Space
// activate it, and it gives press feedback. Pass undefined to disable.
export function pressable(onActivate) {
  return {
    role: 'button',
    tabIndex: onActivate ? 0 : undefined,
    'aria-disabled': onActivate ? undefined : true,
    onClick: onActivate,
    onKeyDown: onActivate
      ? (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onActivate(e);
          }
        }
      : undefined,
  };
}

const ACTIVE = '&:not([aria-disabled="true"]):active';

// Spread into the Box's sx; add `transform 160ms` to its transition.
export const pressSx = {
  [ACTIVE]: { transform: 'scale(0.97)' },
  '&:focus-visible': { outline: '2px solid', outlineColor: 'primary.main', outlineOffset: 2 },
  '@media (prefers-reduced-motion: reduce)': { [ACTIVE]: { transform: 'none' } },
};

export const PRESS_ACTIVE = ACTIVE;
